<template>
    <div>
        <div>
            <banner/>
        </div>
        <div class="animate__animated  animate__fadeIn">
            <div class="bg">
                <img src="@/assets/home/bgLeft.png" alt="" class="bgLeft">
                <img src="@/assets/home/bgRight.png" alt="" class="bgRight">
                <div class="about animate__animated animate__fadeInLeft">
                    <div class="title">
                        ABOUT
                        <h1>关于我们</h1>
                        <div>
                            <i></i> <i></i>
                        </div>
                    </div>
                    <div ref="text" class="text">
                        <div>
                            <p>
                                南京星谱智信息科技有限公司以南京航空航天大学高水平青年拔尖、青年托举人才为核心支撑，研究院技术人员为工程实现主体，进行“电磁频谱管控、天地一体化网络、无人机集群智能组网”等国家重大应用需求的核心难题和“卡脖子”技术的攻关。</p>
                            <p style="margin-top: 20px">
                                在电磁频谱领域从事面向世界前沿和国家战略需求的国际一流水平的科学研究、国家重大仪器的研制与运行应用，以期不断做出基础性、战略性、前瞻性的重大创新贡献，成为我国独具特色、不可或缺与不可替代的创新研究机构。</p>
                        </div>
                        <div @click="activeChange(2)" class="button">了解更多</div>
                    </div>
                    <img src="@/assets/home/building.png" alt="" ref="img">
                </div>
            </div>
            <div class="solution" ref="solution" v-if="pageWidth>1000">
                <div class="title">
                    SOLUTION
                    <h1>解决方案</h1>
                    <div>
                        <i></i> <i></i>
                    </div>
                </div>
                <div class="image">
                    <div class="img_box" @mouseover="changeText(1)" @click="activeChange(3,1)">
                        <div>
                        </div>
                        <div class="shade"></div>
                        <p><span></span>频谱认知</p>
                    </div>
                    <div class="img_box" @mouseover="changeText(2)" @click="activeChange(3,2)">
                        <div class="img"></div>
                        <div class="shade"></div>
                        <p><span></span>智能化</p>
                    </div>
                </div>
                <div class="text animate__animated  animate__fadeIn" v-show="key===1">
                    <p>频谱认知</p>
                    <p>
                        无人机频谱认知仪将无人机与传统频谱监测技术相结合，突破了三维立体频谱成像机理、空基协同对地频谱观测机理、电磁频谱空间预测推理规律和频谱态势重构机理等科学和技术难题，具备低功耗、轻重量、高灵敏度、高精度、协同化、智能化的特点，可应用于空间频谱数据采集、三维频谱地图测绘、电磁地图导航、天线方向图测量、频谱资源管控、辐射源查找和频谱对抗等领域。</p>
                </div>
                <div class="text animate__animated  animate__fadeIn" v-show="key===2">
                    <p>智能化</p>
                    <p>
                        智能化利用人工智能、大数据、物联网等先进技术，赋予设备、系统和产品自主决策、自动控制、自我学习的能力。我们的技术可以运用到智能家居、智慧城市、智能制造、智能交通等各个领域，为提高生产效率、优化资源利用、改善生活品质发挥着重要作用。智能化技术还能结合云计算和大数据分析，实现数据共享和资源优化，推动社会信息化和产业升级。</p>
                </div>
            </div>
            <div class="solution" ref="solution" v-else>
                <div class="title">
                    SOLUTION
                    <h1>解决方案</h1>
                    <div>
                        <i></i> <i></i>
                    </div>
                </div>
                <div class="card" @mouseover="changeText(1)" @click="activeChange(3,1)">
                    <img src="@/assets/home/img1.png" alt="">
                    <div class="text animate__animated  animate__fadeIn">
                        <p>频谱认知</p>
                        <p>
                            无人机频谱认知仪将无人机与传统频谱监测技术相结合，突破了三维立体频谱成像机理、空基协同对地频谱观测机理、电磁频谱空间预测推理规律和频谱态势重构机理等科学和技术难题，具备低功耗、轻重量、高灵敏度、高精度、协同化、智能化的特点，可应用于空间频谱数据采集、三维频谱地图测绘、电磁地图导航、天线方向图测量、频谱资源管控、辐射源查找和频谱对抗等领域。</p>
                    </div>
                </div>

                <div class="card" @mouseover="changeText(2)" @click="activeChange(3,2)">
                    <img src="@/assets/home/img2.png" alt="">
                    <div class="text animate__animated  animate__fadeIn">
                        <p>智能化</p>
                        <p>
                            智能化利用人工智能、大数据、物联网等先进技术，赋予设备、系统和产品自主决策、自动控制、自我学习的能力。我们的技术可以运用到智能家居、智慧城市、智能制造、智能交通等各个领域，为提高生产效率、优化资源利用、改善生活品质发挥着重要作用。智能化技术还能结合云计算和大数据分析，实现数据共享和资源优化，推动社会信息化和产业升级。</p>
                    </div>
                </div>

            </div>
<!--            <div class="bg">-->
<!--                <img src="@/assets/home/bgLeft.png" alt="" class="bgLeft">-->
<!--                <img src="@/assets/home/bgRight.png" alt="" class="bgRight">-->
<!--                <div class="news">-->
<!--                    <div class="title">-->
<!--                        NEWS-->
<!--                        <h1>公司动态</h1>-->
<!--                        <div>-->
<!--                            <i></i> <i></i>-->
<!--                        </div>-->
<!--                    </div>-->
<!--&lt;!&ndash;                    <div class="button" @click="activeChange(4)">了解更多</div>&ndash;&gt;-->
<!--                    <div class="card_box">-->
<!--                        <div class="card">-->
<!--                            <img src="../assets/home/img3.png" alt="">-->
<!--                            <p>天地一体频谱认知智能创新研究院项目</p>-->
<!--                            <p>2023-12-13</p>-->
<!--&lt;!&ndash;                            <p>查看详情</p>&ndash;&gt;-->
<!--                        </div>-->
<!--&lt;!&ndash;                        <div class="card">&ndash;&gt;-->
<!--&lt;!&ndash;                            <img src="../assets/home/img4.png" alt="">&ndash;&gt;-->
<!--&lt;!&ndash;                            <p>xxxxxxxxxxxxxxxxxx</p>&ndash;&gt;-->
<!--&lt;!&ndash;                            <p>xxxxxxxxxxx</p>&ndash;&gt;-->
<!--&lt;!&ndash;                            <p>查看详情</p>&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--&lt;!&ndash;                        <div class="card">&ndash;&gt;-->
<!--&lt;!&ndash;                            <img src="../assets/home/img5.png" alt="">&ndash;&gt;-->
<!--&lt;!&ndash;                            <p>xxxxxxxxxxxxxxxxxx</p>&ndash;&gt;-->
<!--&lt;!&ndash;                            <p>xxxxxxxxxxx</p>&ndash;&gt;-->
<!--&lt;!&ndash;                            <p>查看详情</p>&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
        </div>
    </div>
</template>

<script>
import Banner from '@/components/Banner.vue'

export default {
    name: "Index",
    components: {
        Banner
    },
    data() {
        return {
            key: 1,
            pageWidth: window.innerWidth
        }
    },
    mounted() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        window.addEventListener('resize', this.handleResize);
        window.addEventListener('scroll', this.handleScroll);
        this.$nextTick(() => {
            const solution = this.$refs.solution;
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        solution.classList.add('animate__animated', 'animate__fadeInRight');
                        observer.disconnect(); // 停止观察
                    }
                });
            });
            observer.observe(solution); // 开始观察solution元素
        })
        this.$nextTick(() => {
            const text = this.$refs.text;
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        text.classList.add('animate__animated', 'animate__fadeInLeft');
                        observer.disconnect(); // 停止观察
                    }
                });
            });
            observer.observe(text);
        })
        this.$nextTick(() => {
            const img = this.$refs.img;
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        img.classList.add('animate__animated', 'animate__fadeInRight');
                        observer.disconnect(); // 停止观察
                    }
                });
            });
            observer.observe(img);
        })
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        toPage(path) {
            this.$router.push({path: path}).catch(err => {

            })
        },
        activeChange(index, value) {
            sessionStorage.setItem('key', index);
            switch (index) {
                case 2:
                    this.toPage('/about.html')
                    break
                case 3:
                    if (value === 1) {
                        this.toPage('/monitor.html')
                    } else {
                        this.toPage('/ibos.html')
                    }
                    break
                case 4:
                    this.toPage('/news.html')
                    break
            }
        },
        changeText(index) {
            this.key = index
        },
        handleResize() {
            this.pageWidth = window.innerWidth;
        }
    }

}
</script>

<style scoped lang="less">
@import "../styles/index";
</style>
